<script>
import AddOppositeStreet from '@/modules/form-details/components/add-opposite-street/AddOppositeStreet.vue';
import { mapActions, mapGetters } from 'vuex';
import DatePicker from '@/components/datepicker/DatePicker.vue';
import InfoPopOver from '@/components/info-pop-over/InfoPopOver.vue';
import { FORM_DATA_VALUES } from '@/modules/constants';
import { getEuropeanDate } from '../../../../libs/utils';

const DEFAULT_STANDARD_LENGTH = 'Länge in m';

export default {
  name: 'SecondForm',
  components: { InfoPopOver, DatePicker, AddOppositeStreet },
  data() {
    return {
      formDataState: {
        zipCode: '',
        length: DEFAULT_STANDARD_LENGTH,
        dateFrom: '',
        dateTo: '',
        oppositeStreet: '',
        street: '',
        streetNr: '',
        timeEnd: '',
        timeStart: '',
        DEFAULT_STANDARD_LENGTH
      },
      datePickerOpen: false
    };
  },
  computed: {
    ...mapGetters([
      'priceInfo',
      'priceNotExists',
      'formData',
      'priceNotExistsForSecondForm',
      'prices',
      'formSubmitted',
      'isFormDetailsEdit',
      'customer'
    ])
  },
  mounted() {
    this.formDataState = this.formData.secondForm ? this.formData.secondForm : this.formDataState;
    this.$store.commit('SET_SELECTION_POPUP_LEVEL', 1);
  },
  updated() {
    this.formDataState = this.formData.secondForm;
    this.updateFormErrorAction({ secondForm: true });
    if (
      this.formDataState &&
      this.formData.secondFormEnabled &&
      !(
        this.formDataState.street &&
        this.formDataState.streetNr &&
        this.formDataState.length > 1 &&
        this.formData.secondForm.dateTo &&
        this.formData.secondForm.dateFrom
      )
    ) {
      this.updateFormErrorAction({ secondForm: false });
    }
    if (this.priceNotExistsForSecondForm) {
      this.updateFormErrorAction({ secondForm: false });
    }
  },
  methods: {
    ...mapActions([
      'getPriceInfoAction',
      'setExistsPriceAction',
      'resetPriceInfoAction',
      'updateFormDataAction',
      'updateSecondFormDataAction',
      'updateFormErrorAction'
    ]),
    toggleForm: function() {
      this.updateFormDataAction({
        secondFormEnabled: !this.formData.secondFormEnabled
      });
      this.updateFormErrorAction({ secondForm: true });
    },
    addForOppositeStreetTo: function(event) {
      this.updateSecondFormDataAction({
        oppositeStreet: event.target.checked
      });
    },
    onFormChange: function(event) {
      this.$store.commit('SET_SELECTION_POPUP_ZIPID_SECOND', null);
      this.$store.commit('SET_SELECTION_POPUP_LEVEL', 1);

      const zipCodeValue = event.target.value;
      if (zipCodeValue.length === 5) {
        this.getPriceInfoAction({
          zipcode: zipCodeValue,
          priceForSecondForm: true
        });

        this.updateSecondFormDataAction({
          zipCode: zipCodeValue
        });
      }
      if (zipCodeValue.length === 0) {
        this.updateFormErrorAction({ secondForm: false });

        this.updateSecondFormDataAction({ zipCode: zipCodeValue });
      }
    },

    setFormValue: function(key) {
      return this.priceInfo.secondFormPrice ? this.priceInfo.secondFormPrice[key] : '';
    },

    getStandardLengths: function() {
      return this.priceInfo.secondFormPrice && this.priceInfo.secondFormPrice.standard_laenge
        ? this.priceInfo.secondFormPrice.standard_laenge
        : [];
    },
    onDateShow: function() {
      this.datePickerOpen = false;
    },
    onDateSelect: function(date, name) {
      if (date && name) {
        if (date.includes('/')) {
          date = getEuropeanDate(date);
        }
      }
      this.formDataState[name] = date;
      let dateUpdateObject = {};

      if (name === 'dateFrom') {
        if (!this.formData.secondForm || !this.formData.secondForm.dateTo) {
          dateUpdateObject = {
            dateFrom: date,
            dateTo: date
          };
        } else {
          dateUpdateObject = {
            dateFrom: date
          };
        }
      } else {
        dateUpdateObject = {
          dateTo: date
        };
      }

      // Check if dateTo is past of dateFrom
      if (this.formDataState.dateTo && this.formDataState.dateFrom) {
        let from = this.formDataState.dateFrom.split('.');
        let to = this.formDataState.dateTo.split('.');

        let dateObjFrom = new Date(from[2], from[1] - 1, from[0]);
        let dateObjTo = new Date(to[2], to[1] - 1, to[0]);

        if (dateObjTo < dateObjFrom) {
          this.formDataState.dateTo = '';
          dateUpdateObject.dateTo = '';
          alert('Das Enddatum darf nicht in der Vergangenheit liegen. Bitte geben Sie ein korrektes Datum an.');
          this.datePickerOpen = true;
        }
      }

      this.updateSecondFormDataAction(dateUpdateObject);

      if (
        this.priceInfo.secondFormPrice &&
        this.priceInfo.secondFormPrice.standard_laenge &&
        !this.formData.secondForm.length
      ) {
        this.updateSecondFormDataAction({ length: this.priceInfo.secondFormPrice.standard_laenge[0] });
      }
    },

    renderPopUpHeadline: function() {
      const label = '<strong>Zusätzlich zweite Halteverbotszone mitbestellen</strong>';
      if (this.customer && (this.customer.bsr || this.customer.kuchenaktuell)) {
        return label;
      }
      const price =
        this.prices && this.prices.secondForm && this.formData.secondFormEnabled
          ? this.prices.secondForm.secondFormPrice - this.prices.secondForm.totalOppositeStreetFee + ' €'
          : '';
      return label + '<span class="price-info">' + price + '</span>';
    },
    renderLengthValue() {
      return this.formDataState.length === DEFAULT_STANDARD_LENGTH
        ? DEFAULT_STANDARD_LENGTH
        : this.formDataState.length + ' Meter';
    },
    toggle25meter: function(state) {
      this.formData.length = DEFAULT_STANDARD_LENGTH;
      if (state) {
        this.formData.length = FORM_DATA_VALUES.LONGER_THAN_25_METERS;
      }
      this.moreAs25Meter = state;
    }
  }
};
</script>

<template>
  <div class="form-details-second-form">
    <div class="mb-10">
      <info-pop-over
        :checked="this.formData.secondFormEnabled"
        :headline="renderPopUpHeadline()"
        pop-up-headline="Info zweite Halteverbotszone"
        pop-up-text="Sie können ganz einfach eine zweite Halteverbotszone in diesem Bestellprozess mit bestellen, z.B. für Ihre neue Einzugsadresse."
        check-box-id="second-form-info"
        :enable-pop-up="true"
        :on-checked="toggleForm"
      />
    </div>

    <div class="row" v-if="this.formData.secondFormEnabled">
      <div class="formular">
        <div class="width-100 mb-5">
          <form id="vwo-hv-form-step-2 " @submit.prevent>
            <div class="col-sm-6 pr-md-5 pr-sm-5">
              <table class="second-form-table">
                <tbody>
                  <tr>
                    <td class="pr-5">
                      <input
                        placeholder="PLZ"
                        type="text"
                        class="width-100 form-control check-form2"
                        maxlength="5"
                        minlength="5"
                        :value="this.formData.secondForm ? this.formData.secondForm.zipCode : ''"
                        @change="
                          event => {
                            formDataState.zipCode = event.target.value;
                          }
                        "
                        v-bind:class="
                          formSubmitted && formData.secondForm && !formData.secondForm.zipCode
                            ? 'form-control check-form2 error '
                            : 'form-control check-form2'
                        "
                        @input="onFormChange"
                      />
                    </td>
                    <td class="pl-5">
                      <input
                        placeholder="Stadt"
                        v-if="!priceNotExistsForSecondForm"
                        class="only_one_city form-control width-100"
                        :value="setFormValue('stadt')"
                        readonly="readonly"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>

              <span class="hinweis_box"></span>
              <div class="clear"></div>
            </div>
            <div class="col-sm-6 pl-md-5 pl-sm-5">
              <table class="second-form-table">
                <tbody>
                  <tr>
                    <td class="pr-5">
                      <input
                        :disabled="!(formData.secondForm && formData.secondForm.zipCode)"
                        class="form-control check-form2"
                        type="text"
                        placeholder="Straße"
                        :value="formDataState ? formDataState.street : ''"
                        v-bind:class="
                          formSubmitted && formData.secondForm && !formData.secondForm.street
                            ? 'form-control check-form2 error '
                            : 'form-control check-form2'
                        "
                        @change="
                          event => {
                            formDataState.street = event.target.value;
                            updateSecondFormDataAction({
                              street: formDataState.street
                            });
                          }
                        "
                        @keyup="event => (formDataState.street = event.target.value)"
                      />
                    </td>
                    <td class="pl-5">
                      <input
                        :disabled="!(formData.secondForm && formData.secondForm.zipCode)"
                        class="text-center form-control check-form2"
                        type="text"
                        :value="formDataState ? formDataState.streetNr : ''"
                        placeholder="Nr."
                        @change="
                          event => {
                            formDataState.streetNr = event.target.value;
                            updateSecondFormDataAction({
                              streetNr: formDataState.streetNr
                            });
                          }
                        "
                        @keyup="event => (formDataState.streetNr = event.target.value)"
                        v-bind:class="
                          formSubmitted && formData.secondForm && !formData.secondForm.streetNr
                            ? 'form-control check-form2 error '
                            : 'form-control check-form2'
                        "
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </form>
          <div class="clear"></div>
        </div>

        <div class="no-price-found" v-if="priceNotExistsForSecondForm">
          Für diese Postleitzahl müssen wir immer einen tagesaktuellen Preis einholen, oder die von Ihnen eingegebene
          Postleitzahl ist ungültig. <br />
          Bitte rufen Sie uns unter: <strong>030 / 627 35 160 </strong> an oder erfragen Sie Ihren Preis über unser
          <a href="preisanfrage.html" title="Preisanfrageformular" style="color: #01456A">Preisanfrageformular.</a>
        </div>

        <div class="width-100 mb-5">
          <div class="col-lg-6">
            <table class="second-form-table">
              <tbody>
                <tr>
                  <td class="pr-5">
                    <date-picker
                      :disabled="!(formData.secondForm && formData.secondForm.zipCode)"
                      place-holder="von Datum"
                      input-id="second-form-date-from"
                      :value="formData.secondForm ? formData.secondForm.dateFrom : ''"
                      name="dateFrom"
                      @onDateSelected="onDateSelect"
                      :on-select="onDateSelect"
                      v-bind:class="
                        formSubmitted && formData.secondForm && !formData.secondForm.dateFrom
                          ? 'form-control error '
                          : 'form-control'
                      "
                    />
                  </td>
                  <td class="pl-5">
                    <date-picker
                      :disabled="!(formData.secondForm && formData.secondForm.zipCode)"
                      place-holder="bis Datum"
                      input-id="second-form-date-to"
                      :value="formData.secondForm ? formData.secondForm.dateTo : ''"
                      name="dateTo"
                      @onDateSelected="onDateSelect"
                      v-bind:class="
                        formSubmitted && formData.secondForm && !formData.secondForm.dateTo
                          ? 'form-control error '
                          : 'form-control'
                      "
                      :on-select="onDateSelect"
                      :show="datePickerOpen"
                      @onDateShow="onDateShow"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-lg-6">
            <table class="second-form-table">
              <tbody>
                <tr>
                  <td class="pr-5">
                    <div class="cixSelectBox pull-left mr-10 pull-left">
                      <select
                        v-if="!customer || (customer && !customer.bsr)"
                        :disabled="!(formData.secondForm && formData.secondForm.zipCode)"
                        @change="
                          event => {
                            formDataState.timeStart = event.target.value;
                            updateSecondFormDataAction({
                              timeStart: formDataState.timeStart
                            });
                          }
                        "
                        class="form-control"
                        style="width: 118% !important;"
                      >
                        <option selected="selected" value="07:00">07:00</option>
                        <option value="08:00">08:00</option>
                        <option value="09:00">09:00</option>
                        <option value="10:00">10:00</option>
                        <option value="11:00">11:00</option>
                        <option value="12:00">12:00</option>
                        <option value="13:00">13:00</option>
                        <option value="14:00">14:00</option>
                        <option value="15:00">15:00</option>
                        <option value="16:00">16:00</option>
                      </select>

                      <select
                        v-else
                        :disabled="!(formData.secondForm && formData.secondForm.zipCode)"
                        @change="
                          event => {
                            formDataState.timeStart = event.target.value;
                            updateSecondFormDataAction({
                              timeStart: formDataState.timeStart
                            });
                          }
                        "
                        class="form-control"
                        style="width: 118% !important;"
                      >
                        <option value="06:00">06:00</option>
                        <option value="07:00">07:00</option>
                        <option value="08:00">08:00</option>
                        <option value="09:00">09:00</option>
                        <option value="10:00">10:00</option>
                        <option value="11:00">11:00</option>
                        <option value="12:00">12:00</option>
                        <option value="13:00">13:00</option>
                        <option value="14:00">14:00</option>
                        <option value="15:00">15:00</option>
                        <option value="16:00">16:00</option>
                        <option value="17:00">17:00</option>
                        <option value="18:00">18:00</option>
                        <option value="19:00">19:00</option>
                        <option value="20:00">20:00</option>
                      </select>
                    </div>
                  </td>
                  <td class="pl-5">
                    <div class="cixSelectBox">
                      <select
                        v-if="!customer || (customer && !customer.bsr)"
                        :disabled="!(formData.secondForm && formData.secondForm.zipCode)"
                        @change="
                          event => {
                            formDataState.timeEnd = event.target.value;
                            updateSecondFormDataAction({
                              timeEnd: formDataState.timeEnd
                            });
                          }
                        "
                        style="width: 117% !important;"
                      >
                        <option value="17:00">17:00</option>
                        <option value="18:00">18:00</option>
                        <option value="19:00">19:00</option>
                        <option value="20:00">20:00</option>
                        <option value="21:00">21:00</option>
                        <option value="22:00">22:00</option>
                      </select>

                      <select
                        v-else
                        :disabled="!(formData.secondForm && formData.secondForm.zipCode)"
                        @change="
                          event => {
                            formDataState.timeEnd = event.target.value;
                            updateSecondFormDataAction({
                              timeEnd: formDataState.timeEnd
                            });
                          }
                        "
                        style="width: 117% !important;"
                      >
                        <option value="06:00">06:00</option>
                        <option value="07:00">07:00</option>
                        <option value="08:00">08:00</option>
                        <option value="09:00">09:00</option>
                        <option value="10:00">10:00</option>
                        <option value="11:00">11:00</option>
                        <option value="12:00">12:00</option>
                        <option value="13:00">13:00</option>
                        <option value="14:00">14:00</option>
                        <option value="15:00">15:00</option>
                        <option value="16:00">16:00</option>
                        <option value="17:00">17:00</option>
                        <option value="18:00">18:00</option>
                        <option value="19:00">19:00</option>
                        <option value="20:00">20:00</option>
                        <option value="21:00">21:00</option>
                        <option value="22:00">22:00</option>
                      </select>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="clear"></div>
        </div>

        <div class="width-100 mb-5">
          <div class="col-sm-6 pr-md-5 pr-sm-5">
            <div class="cixSelectBox" style="width:100%;">
              <select v-if="!customer || (customer && !customer.bsr)">
                :required="true" class="stadt_laenge check-form2 form-control " placeholder="Länge in m:" @change="
                event => { formDataState.length = event.target.value; updateSecondFormDataAction({ length:
                formDataState.length }); } " >
                <option v-if="getStandardLengths().length === 0" value="0">Länge in m</option>
                <option
                  v-for="(length, index) in getStandardLengths()"
                  :key="length"
                  :value="length"
                  :selected="length === formData.secondForm.length || index === 0"
                >
                  {{ length }} Meter
                </option>
                <option v-if="getStandardLengths().length > 0 && !isFormDetailsEdit" value=">25"
                  >Mehr als 25 Meter</option
                >
              </select>

              <select v-else>
                :required="true" class="stadt_laenge check-form2 form-control " placeholder="Länge in m:" @change="
                event => { formDataState.length = event.target.value; updateSecondFormDataAction({ length:
                formDataState.length }); } " >
                <option @click="formDataState.length = 20" value="20">20 Meter</option>
                <option @click="formDataState.length = 40" value="40">40 Meter</option>
                <option @click="formDataState.length = 60" value="60">60 Meter</option>
                <option @click="formDataState.length = 80" value="80">80 Meter</option>
                <option @click="formDataState.length = 100" value="100">100 Meter</option>
              </select>
            </div>
          </div>

          <input type="hidden" id="II_wofur" name="II_wofur" value="Privatumzug" />
        </div>

        <div class="clear"></div>

        <div
          v-if="priceInfo.secondFormPrice && formData.secondForm.dateFrom && formData.secondForm.zipCode"
          class="mt-10 pl-15 pr-15"
        >
          <add-opposite-street
            v-if="priceInfo.secondFormPrice.beidseitig_aufstellung"
            :enable-pop-up="false"
            :price="priceInfo.genehmigung_brutto"
            :on-checked="addForOppositeStreetTo"
            check-box-id="opposite-street-level-2"
            :fill="this.formData.secondForm.oppositeStreet"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
@import 'SecondFormStyles';
</style>
